import Vue from 'vue'
import Buefy from 'buefy'
import 'buefy/lib/buefy.css'
import '../assets/css/farsoft.css'

Vue.use(Buefy)
